import { cn } from "@gymflow/helpers";
import { useHistory } from "react-router";

import { usePortalRoutes } from "../../hooks";
import { SignUp } from "../../providers/authentication/SessionOverlay/SignUp";
import { RouteFeature } from "../../routes";

export function SiteRegistration() {
  const { isEmbed, createSiteOrEmbedLink } = usePortalRoutes();
  const history = useHistory();

  return (
    <div
      className={cn(
        "track-height flex justify-center overflow-y-auto bg-gray-0 dark:bg-gray-950",
        {
          "h-fit": isEmbed,
          "h-full": !isEmbed,
        },
      )}
    >
      <div className="flex h-full w-[calc(100vw-2rem)] max-w-lg">
        <SignUp
          onSuccess={() => {
            history.push(createSiteOrEmbedLink(RouteFeature.SiteProfile));
          }}
        />
      </div>
    </div>
  );
}
